// extracted by mini-css-extract-plugin
var _1 = "DeletedView-module__animateUploadProgressBarWidth--Omxxi";
var _2 = "DeletedView-module__animatedBackground--kdxWG";
var _3 = "DeletedView-module__container--xR7UJ";
var _4 = "DeletedView-module__emptyWrapper--tJew8";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "emptyWrapper" }
